import CompanyProfile from 'models/companyProfile';
import { CopilotResponseAnnotations } from 'models/copilot/copilotConversation';
import CompanyProfileDTO from 'models/dto/companyProfileDTO';
import { CopilotResponseAnnotationsDTO } from 'models/dto/copilot/copilotConversationDTO';
import { mapFromPromptResponseCitations } from './copilotMapping';

export function mapFromCompanyProfile(companyProfileDTO: CompanyProfileDTO | undefined): CompanyProfile | undefined {
  if (companyProfileDTO) {
    const output = new CompanyProfile();
    output.website = companyProfileDTO.website || '';
    output.numberOfEmployees = companyProfileDTO.numberOfEmployees || 0;
    output.industry = companyProfileDTO.industry || '';
    output.companyIntelligence = companyProfileDTO.companyIntelligence || '';
    output.marketAndCustomers = companyProfileDTO.marketAndCustomers || '';
    output.technologyAndRegulatory = companyProfileDTO.technologyAndRegulatory || '';
    output.scopeSoftwareDevelopment = companyProfileDTO.scopeSoftwareDevelopment ?? undefined;
    output.scopeFixedOffice = companyProfileDTO.scopeFixedOffice ?? undefined;
    output.annotations = new CopilotResponseAnnotations();
    output.annotations.citations = mapFromPromptResponseCitations(companyProfileDTO.annotations?.citations);
    output.annotations.metadata = companyProfileDTO.annotations?.metadata || [];

    return output;
  }

  return undefined;
}

export function mapToCompanyProfile(companyProfile: CompanyProfile): CompanyProfileDTO {
  const output = new CompanyProfileDTO();
  output.website = companyProfile.website;
  output.numberOfEmployees = companyProfile.numberOfEmployees;
  output.industry = companyProfile.industry;
  output.companyIntelligence = companyProfile.companyIntelligence;
  output.marketAndCustomers = companyProfile.marketAndCustomers;
  output.technologyAndRegulatory = companyProfile.technologyAndRegulatory;
  output.scopeSoftwareDevelopment = companyProfile.scopeSoftwareDevelopment ?? null;
  output.scopeFixedOffice = companyProfile.scopeFixedOffice ?? null;
  output.annotations = new CopilotResponseAnnotationsDTO();
  output.annotations.citations = companyProfile.annotations?.citations || [];
  output.annotations.metadata = companyProfile.annotations?.metadata || [];

  return output;
}
